import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Layout from '@components/common/Layout';
import { getPfmsLink } from '@common/utils';


const Pfms = () => {
    const { customerInfo } = useSelector(state => state.customerReducer);
    let pfmsUrl = '';

    useEffect(async() => {
      pfmsUrl = await getPfmsLink(customerInfo);
      window.parent.document.getElementById('pfmsPage').src = pfmsUrl;

      return pfmsUrl;
    }, []);
    
  return (
    <Layout>    
      <iframe id="pfmsPage" className="con-wrap tablet" style={{ padding: 0 }}/>
    </Layout>
  )
};


export default Pfms;
